<ix-modal-header
  [title]="'Dashboard Configure' | translate"
  [loading]="isFormLoading"
></ix-modal-header>
<mat-card>
  <mat-card-content>
    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset [title]="'System Widgets' | translate">
        <ix-slide-toggle
          *ngFor="let widget of systemWidgets"
          [formControlName]="extractName(widget)"
          [label]="extractName(widget) | translate"
        ></ix-slide-toggle>
      </ix-fieldset>

      <ix-fieldset [title]="'Storage Widgets' | translate">
        <ix-slide-toggle
          *ngFor="let widget of storageWidgets"
          [formControlName]="extractName(widget)"
          [label]="extractName(widget) | translate"
        ></ix-slide-toggle>
      </ix-fieldset>

      <ix-fieldset [title]="'Network Widgets' | translate">
        <ix-slide-toggle
          *ngFor="let widget of networkWidgets"
          [formControlName]="extractName(widget)"
          [label]="extractName(widget) | translate"
        ></ix-slide-toggle>
      </ix-fieldset>

      <ix-form-actions>
        <button
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>
      </ix-form-actions>
    </form>
  </mat-card-content>
</mat-card>
